// extracted by mini-css-extract-plugin
module.exports = {"root":"AddButton_root__3a6b5","label":"AddButton_label__E_I_V"};